export default {
    // Set Filter
    selectAll: "Select All",
    selectAllSearchResults: "Select All Search Results",
    searchOoo: "Search...",
    blanks: "Blanks",
    noMatches: "No matches.",
  
    // Number Filter & Text Filter
    filterOoo: "Filter...",
    equals: "Equals",
    notEqual: "Not equal",
  
    // Number Filter
    lessThan: "Less than",
    greaterThan: "Greater than",
    lessThanOrEqual: "Less than or equal",
    greaterThanOrEqual: "Greater than or equal",
    inRange: "In range",
    inRangeStart: "To",
    inRangeEnd: "From",
  
    // Text Filter
    contains: "Contains",
    notContains: "Not contains",
    startsWith: "Starts with",
    endsWith: "Ends with",
  
    // Date Filter
    dateFormatOoo: "Yyyy-mm-dd",
  
    // Filter Conditions
    andCondition: "AND",
    orCondition: "OR",
  
    // Filter Buttons
    applyFilter: "Apply",
    resetFilter: "Reset",
    clearFilter: "Clear",
    cancelFilter: "Cancel",
  
    // Side Bar
    columns: "Columns",
    filters: "Filters",
  
    // columns tool panel
    pivotMode: "Pivot Mode",
    groups: "Row Groups",
    rowGroupColumnsEmptyMessage: "Drag here to set row groups",
    values: "Values",
    valueColumnsEmptyMessage: "Drag here to aggregate",
    pivots: "Column Labels",
    pivotColumnsEmptyMessage: "Drag here to set column labels",
  
    // Header of the Default Group Column
    group: "Group",
  
    // Other
    loadingOoo: "Loading...",
    noRowsToShow: "No Rows To Show",
    enabled: "Enabled",
  
    // Menu
    pinColumn: "Pin Column",
    pinLeft: "Pin Left",
    pinRight: "Pin Right",
    noPin: "No Pin",
    valueAggregation: "Value Aggregation",
    autosizeThiscolumn: "Autosize This Column",
    autosizeAllColumns: "Autosize All Columns",
    groupBy: "Group by",
    ungroupBy: "Un-Group by",
    resetColumns: "Reset Columns",
    expandAll: "Expand All",
    collapseAll: "Close All",
    copy: "Copy",
    ctrlC: "Ctrl+C",
    copyWithHeaders: "Copy With Headers",
    paste: "Paste",
    ctrlV: "Ctrl+V",
    export: "Export",
    csvExport: "CSV Export",
    excelExport: "Excel Export (.xlsx)",
    excelXmlExport: "Excel Export (.xml)"
  };
  